import React from 'react'
import { Link } from "react-router-dom";
import HomeAbout from '../home/HomeAbout';
import HomeMission from '../home/HomeMission';
import WorkingProcess from '../home/WorkingProcess';
import WhyChoose from '../home/WhyChoose';
import IndustriesServe from '../home/IndustriesServe';
import FounderMessage from './FounderMessage';

const About = () => {
    return (
        <>

            <section className="section-breadcrumb main-wrapper">
                <div className="breadcrumb-area">
                    <div className="container">
                        <div className="breadcrumb-wrapper">
                            <nav className="breadcrumb">
                                <Link className="breadcrumb-item" to="/">Home</Link>
                                <span className="breadcrumb-item active" aria-current="page">About</span>
                            </nav>
                            <h1 className="breadcrumb-title">About Us</h1>
                        </div>
                        <div className="breadcrumb-bg-block">
                            <img src="assets/images/breadcrumb-bg.jpg" alt="breadcrumb-bg" width={1920} height={448} className="img-cover" />
                            <img src="assets/images/breadcrumb-shape.png" alt="breadcrumb-shape" width={1033} height={448} />
                        </div>
                    </div>
                </div>
            </section>
            <br />
            <br />
            <br />
            <HomeAbout />
            <FounderMessage />

            {/* <section className="service-section-4 section-space" style={{ marginTop: "-40px" }}>
                <div className="container">
                    <div className="service-wrapper-4">
                        <div className="row g-4">
                            <div className="col-lg-6">
                                <div className="team-content-4 sticky-style">
                                    <div className="section-content-block ">
                                        <span className="section-tag wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Welcome to Rahul Logistics Katni</span>
                                        <h2 className="section-title is-text-dark">
                                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                                Safety Policy
                                            </div>
                                        </h2>
                                    </div>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                        “Safety is a legitimate personal expectation and a constant individual responsibility. Every member of staff should be able to go home at the end of the working day without having suffered or caused harm in any way.”
                                    </p>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                        We as an organization are committed to safe operations at different levels of our organization and are sincerely following our safety policy which is Safety To 3M’s ( Men, Material and Machine) and we strongly believe that by doing the same we will help in protecting the Environment as well.
                                    </p>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                        We believe in not just doing business but doing the same safely in all aspects of our operations like the 3M and to ensure that all our operations are safe for business.
                                    </p>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                        Being in the road service industry where our operations are exposed to 3M are not limited to our organization alone. It is here, where we feel that we have a much more important role in the safety cause, where by doing operations safely we will ensure safety not just to our operations but also to all concerned.
                                    </p>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                        We believe that all customers associated with us have the right that their consignments reach safely or the personnel manning our vehicles are trained for safe operations and the vehicles are safe enough for the journey making the entire process of our business safe.
                                    </p>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                        Everyone in this organization is committed to the safe operations and Safety To 3M’s.
                                    </p>

                                    <Link to="/contact-us" className="btn btn-secondary-alt mt-5 wow fadeInUp" data-wow-delay=".5s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                                        Contact Us
                                        <div className="btn-icon">
                                            <span>
                                                <i className="fa-regular fa-arrow-right" />
                                            </span>
                                            <span>
                                                <i className="fa-regular fa-arrow-right" />
                                            </span>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="service-image-4">
                                    <div className="service-image">
                                        <img src="assets/images/home-3/service/home-4-02.jpg" alt="img" />
                                        <div className="service-content">
                                            <div className="service-icon-items">
                                                <div className="icon">
                                                    <img src="assets/images/home-3/service/icon-5.svg" alt="img" />
                                                </div>
                                                <h3><a to="service-details.html">Road Transportation</a></h3>
                                            </div>
                                            <p>We are committed to providing the best service to ensure your success..</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="service-image-4 mt-0">
                                    <div className="service-image">
                                        <img src="assets/img/Rail Transportation.jpg" alt="img" />
                                        <div className="service-content">
                                            <div className="service-icon-items">
                                                <div className="icon">
                                                    <img src="assets/images/home-3/service/icon-5.svg" alt="img" />
                                                </div>
                                                <h3><a to="service-details.html">Rail Transportation</a></h3>
                                            </div>
                                            <p>We are committed to providing the best service to ensure your success..</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="service-image-4">
                                    <div className="service-image">
                                        <img src="assets/images/home-3/service/home-4-03.jpg" alt="img" />
                                        <div className="service-content">
                                            <div className="service-icon-items">
                                                <div className="icon">
                                                    <img src="assets/images/home-3/service/icon-5.svg" alt="img" />
                                                </div>
                                                <h3><a to="service-details.html">Air Transportation</a></h3>
                                            </div>
                                            <p>We are committed to providing the best service to ensure your success..</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            {/* <section className="service-section-4 section-space" style={{ marginTop: "-40px" }}>
                <div className="container">
                    <div className="service-wrapper-4">
                        <div className="row g-4">
                            <div className="col-lg-6">
                                <div className="team-content-4 sticky-style">
                                    <div className="section-content-block ">
                                        <span className="section-tag wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Welcome to Rahul Logistics Katni</span>
                                        <h2 className="section-title is-text-dark">
                                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                                Our  Profile
                                            </div>
                                        </h2>
                                    </div>
                                    <p  className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign:"justify" }}>
                                        Logistics services play a crucial role in modern supply chains. They involve planning, implementing, and managing the efficient flow of goods, information, and resources, moving products from their point of origin to their destination. These services include transportation, warehousing, inventory management, and order fulfillment. By optimizing these processes, logistics services help businesses reduce costs, improve customer satisfaction, and streamline their operations, thereby enhancing competitiveness in today's global market.
                                    </p>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign:"justify" }}>
                                        Rahul Logistics is a freight company specialising in line haul logistics. Established with the start of this century, we have grown steadily to become one of India’s most in-demand fabric transport companies. Our goal is to understand your business and provide a customised transport solution that includes; competitive rates, an authentic approach to real customer service and a proactive approach to meet your expectations. Founded by team of professionals with collective experience of more than a century, the Rahul Logistics team has proved its excellence to its valuable client, with safe and timely deliveries in every scenario. Rahul Logistics Transport prides itself on honest, reliable and excellent customer service, treating each customer and freight haul with the highest level of personal attention, professionalism and confidentiality. Now venturing out in the field of supply chain, machineries and packer & movers with the same dedication, Rahul Logistics, is again proving its customer, the commitment and in our work.
                                    </p>
                                   
                                    <Link to="/contact-us" className="btn btn-secondary-alt mt-5 wow fadeInUp" data-wow-delay=".5s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                                        Contact Us
                                        <div className="btn-icon">
                                            <span>
                                                <i className="fa-regular fa-arrow-right" />
                                            </span>
                                            <span>
                                                <i className="fa-regular fa-arrow-right" />
                                            </span>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="service-image-4">
                                    <div className="service-image">
                                        <img src="assets/images/home-3/service/home-4-02.jpg" alt="img" />
                                        <div className="service-content">
                                            <div className="service-icon-items">
                                                <div className="icon">
                                                    <img src="assets/images/home-3/service/icon-5.svg" alt="img" />
                                                </div>
                                                <h3><a to="service-details.html">Road Transportation</a></h3>
                                            </div>
                                            <p>We are committed to providing the best service to ensure your success..</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="service-image-4 mt-0">
                                    <div className="service-image">
                                        <img src="assets/img/Rail Transportation.jpg" alt="img" />
                                        <div className="service-content">
                                            <div className="service-icon-items">
                                                <div className="icon">
                                                    <img src="assets/images/home-3/service/icon-5.svg" alt="img" />
                                                </div>
                                                <h3><a to="service-details.html">Rail Transportation</a></h3>
                                            </div>
                                            <p>We are committed to providing the best service to ensure your success..</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="service-image-4">
                                    <div className="service-image">
                                        <img src="assets/images/home-3/service/home-4-03.jpg" alt="img" />
                                        <div className="service-content">
                                            <div className="service-icon-items">
                                                <div className="icon">
                                                    <img src="assets/images/home-3/service/icon-5.svg" alt="img" />
                                                </div>
                                                <h3><a to="service-details.html">Air Transportation</a></h3>
                                            </div>
                                            <p>We are committed to providing the best service to ensure your success..</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <HomeMission />
            <WorkingProcess />
            <WhyChoose />
            <IndustriesServe />





        </>
    )
}

export default About